import { render, staticRenderFns } from "./text-collapse.vue?vue&type=template&id=4d214a80&scoped=true&"
import script from "./text-collapse.vue?vue&type=script&lang=js&"
export * from "./text-collapse.vue?vue&type=script&lang=js&"
import style0 from "./text-collapse.vue?vue&type=style&index=0&id=4d214a80&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d214a80",
  null
  
)

export default component.exports